module.exports = __webpack_public_path__ + "media/bg.4898cf80.mp4";